import { Directive } from '@angular/core';

/* eslint-disable @angular-eslint/directive-selector */
/* eslint-disable @angular-eslint/directive-class-suffix */

/** Error message to be displayed for a modus-form-field. */
@Directive({
  selector: 'modus-error',
  standalone: false,
})
export class ModusError {}
